export const isNegativeHighlightedValue = (
  value: unknown,
  highlightNegative: boolean
): boolean =>
  highlightNegative &&
  typeof value === 'number' &&
  Number.isFinite(value) &&
  value < 0;
